export default __webpack_public_path__ + "static/media/soccer-ball.1fe1dc99.png";